import React from "react";
import RefreshIcon from "@material-ui/icons/Refresh";

function RefreshViewIcon() {
  return <RefreshIcon />;
}
export default RefreshViewIcon;
